import React, { useMemo, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import AdminPage from '../../../admin/shared/AdminPage'
import Loading from '../../../../molecules/Loading'
import { dataCatalog } from '../../../../../api/coreData'
import { useSetViewTitle } from '../../../../../redux/slices/appContext'
import EmptySection from '../../../../atoms/EmptySection'
import TableDetails from './TableDetails'
import ApiDetails from './ApiDetails'

function DataSourceDetails () {
  const { datasourceId } = useParams()
  const { data, isLoading } = dataCatalog.useGetCatalogDataSource(datasourceId)
  const setViewTitle = useSetViewTitle()

  const headerTitle = useMemo(() => {
    if (!data?.datasource) return undefined
    return data.datasource.type === 'table' ? 'Edit Table' : 'Edit Pipeline'
  }, [data])

  useEffect(() => {
    if (headerTitle) {
      setViewTitle(headerTitle)
    }
    return () => setViewTitle(undefined)
  }, [headerTitle, setViewTitle])

  if (isLoading) {
    return (
      <AdminPage>
        <Loading />
      </AdminPage>
    )
  }

  if (!data?.datasource) {
    return (
      <AdminPage>
        <EmptySection title='Not Available' description='' />
      </AdminPage>
    )
  }

  const datasource = data?.datasource

  return (
    <AdminPage key='data-source-details-main'>
      {datasource?.type === 'table' ? (
        <TableDetails datasource={datasource} />
      ) : (
        <ApiDetails datasource={datasource} />
      )}
    </AdminPage>
  )
}

DataSourceDetails.propTypes = {
}

export default DataSourceDetails
